import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TermsService } from '../../services/terms.service';
import { CookieContentComponent } from '../cookie-content/cookie-content.component';
import { PrivacyContentComponent } from '../privacy-content/privacy-content.component';
import { TermsContentComponent } from '../terms-content/terms-content.component';

@Component({
  selector: 'app-terms-modal',
  imports: [CookieContentComponent, PrivacyContentComponent, TermsContentComponent],
  templateUrl: './terms-modal.component.html',
  styleUrl: './terms-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsModalComponent {
  public readonly termsService = inject(TermsService);
  public readonly activeTab = signal<'voorwaarden' | 'privacy' | 'cookies'>('voorwaarden');
}
